import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Notifications.types'

@Injectable({ providedIn: 'root' })
export class Notifications_parse_emails_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { email_string: string }): Promise<{ emails?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.email_string)) {
      missingRequiredInParams.push('\'email_string\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/functions/parse_emails_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

